/*
 *
 * Copyright (c) 1999-2021 Luciad All Rights Reserved.
 *
 * Luciad grants you ("Licensee") a non-exclusive, royalty free, license to use,
 * modify and redistribute this software in source and binary code form,
 * provided that i) this copyright notice and license appear on all copies of
 * the software; and ii) Licensee does not utilize the software in a manner
 * which is disparaging to Luciad.
 *
 * This software is provided "AS IS," without a warranty of any kind. ALL
 * EXPRESS OR IMPLIED CONDITIONS, REPRESENTATIONS AND WARRANTIES, INCLUDING ANY
 * IMPLIED WARRANTY OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE OR
 * NON-INFRINGEMENT, ARE HEREBY EXCLUDED. LUCIAD AND ITS LICENSORS SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE AS A RESULT OF USING, MODIFYING
 * OR DISTRIBUTING THE SOFTWARE OR ITS DERIVATIVES. IN NO EVENT WILL LUCIAD OR ITS
 * LICENSORS BE LIABLE FOR ANY LOST REVENUE, PROFIT OR DATA, OR FOR DIRECT,
 * INDIRECT, SPECIAL, CONSEQUENTIAL, INCIDENTAL OR PUNITIVE DAMAGES, HOWEVER
 * CAUSED AND REGARDLESS OF THE THEORY OF LIABILITY, ARISING OUT OF THE USE OF
 * OR INABILITY TO USE SOFTWARE, EVEN IF LUCIAD HAS BEEN ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGES.
 */
/**
 * ControlGroup constructor.
 * @param map the map instance
 * @param options
 * @param [options.domId] reference to DOM id that will host the LayerTree UI
 * @constructor
 */
function ControlGroup(map, options) {
  options = options || {};

  this._map = map;
  this._domNodeId = options.domId || 'controlGroupId';
  this._holderNode = document.createElement('div');
  this._holderNode.id = this._domNodeId;

  map.domNode.appendChild(this._holderNode);

  this._createDOMStructure();
}

ControlGroup.prototype = Object.create(Object.prototype);
ControlGroup.prototype.constructor = ControlGroup;

ControlGroup.prototype._createDOMStructure = function() {
  this._holderNode.classList.add("controlGroup");
};

ControlGroup.prototype.getDomId = function() {
  return this._domNodeId;
};

export {ControlGroup};